import { Popover } from "antd";
import classNames from "classnames";
import { get } from "lodash";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import QuickActionRed from "shared/components/SVG/LMF/QuickActionRed";
import { NAME_SPACES } from "shared/locales/constants";
import { CURRENCY_SYMBOL } from "utils/constants";
import ActionButtons from "../Components/ActionButtons";
import Button from "../Components/Button";
import Head from "../Components/Head";
import InfoBox from "../Components/InfoBox";
import Layout from "../Components/Layout";
import Loading from "../Components/Spin";
import checkMarkChecked from "../Components/svg/check-mark-checked.svg";
import checkMarkUnchecked from "../Components/svg/check-mark-unchecked.svg";

const View = ({
  mainProduct,
  products,
  selectedModules,
  disabled,
  onCheck,
  generalCost,
  onNext,
  loading,
  onBack,
  insurancePlan,
}) => {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.PROCESSES);
  const TRANSLATION = t("B2C_LMF.REINFORCEMENT", { returnObjects: true });
  const totalCost = get(
    selectedModules,
    get(generalCost, "insurancePlan.id"),
    [],
  )
    ?.reduce((acc, curr) => acc + curr.cost, 0)
    ?.toFixed(2);
  const [integer, decimal = ""] = totalCost?.toString()?.split(".") || ["-"];

  const blockSelecting =
    get(selectedModules, mainProduct, []).length >= 1 &&
    products.some(({ weight }) => weight === 2);

  const isMobile = useMediaQuery({ maxWidth: 768 });
  useEffect(() => {
    if (
      products?.length &&
      get(selectedModules, mainProduct, []).length === 0
    ) {
      onCheck({ module: products[0], blockSelecting });
    }
  }, [products]);

  const showInfoBox = products
    .map((_) => get(_, "insurancePlan.name", "").toLowerCase())
    .every((name) => !name.includes("confort"));

  return (
    <>
      <Layout>
        <Head
          description={TRANSLATION.DESCRIPTION}
          title={TRANSLATION.TITLE}
          onBack={onBack}
        />

        <div className="LMF-content lmf__modules lmf__form">
          {showInfoBox && (
            <InfoBox
              variant="danger"
              text={TRANSLATION.HEADER.TEXT}
              icon={<QuickActionRed size={48} />}
            />
          )}
          <div className={"lmf__modules__body"}>
            {loading ? (
              <Loading />
            ) : (
              products
                ?.map((_) => {
                  const [integer, decimal = ""] = _?.cost
                    ?.toString()
                    ?.split(".") || ["-"];
                  return { ..._, integer, decimal };
                })
                .map((product, i) => {
                  const isChecked = get(selectedModules, mainProduct, []).some(
                    ({ insurancePlan }) =>
                      insurancePlan?.id ===
                      get(product, "insurancePlan.id", ""),
                  );

                  const isDisabled = disabled || (!isChecked && blockSelecting);
                  const card = (
                    <div
                      onClick={() =>
                        onCheck({ module: product, blockSelecting })
                      }
                      className={classNames("lmf__modules__body--checkbox", {
                        checked: isChecked,
                        disabled: isDisabled,
                      })}
                    >
                      <div className="--content">
                        <img
                          className="checked-icon"
                          src={checkMarkChecked}
                          alt=""
                        />
                        <img
                          className="unchecked-icon"
                          src={checkMarkUnchecked}
                          alt=""
                        />
                        <div className="--description">
                          <label>
                            {get(product, "insurancePlan.name", "")}
                          </label>
                          <span>
                            {get(product, "insurancePlan.description", "")}
                          </span>
                        </div>
                      </div>

                      <div className="product-price">
                        <span className="lmfAdd--upsell__price">
                          <span className="lmfAdd--upsell__price--integer">
                            {get(product, "integer", "")}
                          </span>
                          <span className="lmfAdd--upsell__price--decimal">
                            <span>
                              ,{get(product, "decimal", "")}{" "}
                              {CURRENCY_SYMBOL[generalCost?.currency]}
                            </span>
                            <span>{TRANSLATION.PER_MONTH}</span>
                          </span>
                        </span>
                      </div>
                    </div>
                  );

                  return isDisabled ? (
                    <Popover
                      key={`product-${i}`}
                      content={TRANSLATION.NOT_COMBINED}
                    >
                      {card}
                    </Popover>
                  ) : (
                    <React.Fragment key={`product-${i}`}>{card}</React.Fragment>
                  );
                })
            )}
          </div>

          {showInfoBox && (
            <div className="lmf__modules__footer">
              {TRANSLATION.FOOTER.TEXT}
            </div>
          )}
        </div>

        <div className="grid--1">
          <div
            className={classNames("lmfAdd--upsell lmf__form", {
              blur: !get(selectedModules, mainProduct, []).length,
            })}
          >
            <span className="lmfAdd--upsell__price">
              <span className="lmfAdd--upsell__price--integer">{integer}</span>
              <span className="lmfAdd--upsell__price--decimal">
                <span>
                  ,{decimal} {CURRENCY_SYMBOL[generalCost?.currency]}
                </span>
                <span>{TRANSLATION.PER_MONTH}</span>
              </span>
            </span>
            <Button
              type={
                get(selectedModules, mainProduct, []).length
                  ? "primary"
                  : "white"
              }
              size="large"
              onClick={onNext}
              disabled={!get(selectedModules, mainProduct, []).length}
            >
              {TRANSLATION.NEXT}
            </Button>
          </div>
          {get(selectedModules, mainProduct, []).length === 0 && (
            <p className="__LMF--link" onClick={() => onNext({ ignore: true })}>
              {TRANSLATION.NO_THANKS}
            </p>
          )}
        </div>
        <ActionButtons
          {...(isMobile && { onBack })}
          className={classNames({
            "w-100": isMobile,
          })}
        />
      </Layout>
    </>
  );
};

export default View;
